<template>
  <div v-if="!show" class="ui active loader"></div>
  <div v-if="show" id="contain" class="ui center aligned padding grid">
    <div class="ui field formulario">
      <div v-for="servicio in servicios" v-bind:key="servicio.value">
        <div class="botonera">
          <i v-if="servicio.key === 'pickup'" class="ui big user outline icon"></i>
          <i v-else-if="servicio.key === 'shophapiick'" class="ui big warehouse icon"></i>
          <i v-else class="ui big warehouse icon"></i>
          <button class="ui fluid large teal button hapiick" id="idBtnServicio" v-on:click="selectedService(servicio)">
            {{ servicio.text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuApt",
  props: ["apm"],
  data() {
    return {
      show: false,
      msg: null,
      type: null,
      title: null,
      token: null,
      closeSession: 1,
      codError: null,
      servicios: [],
      accessCode: null,
      validate_ok: null,
      totalIntentos: 1,
      allowOutsideClick: true,
    };
  },
  created() {
    this.access();
  },
  methods: {
    access() {
      let url = this.$url_hapiick + '/v1/apms/access';
      let headers = {
        'Content-Type': 'application/json'
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url, {
        apm: this.apm,
      },{
        headers: headers
      })
      .then(request => {
        this.token = request.data.token
        this.codError = request.data.error
        if (this.codError) {
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          if (!this.token) {
            this.redirect('',this.title,'','',this.token,this.closeSession);
          } else {
            localStorage.clear();
            localStorage.token = this.token
            localStorage.apm = this.apm
            this.getServicesByApt();
          }
        }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    getServicesByApt() {
      let url = this.$url_hapiick + "/v1/apms/services?apm="+this.apm;
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.get(url,{
        headers: headers
      })
      .then((request) => {
        let ActiveServices = request.data.virtual_services;

        if (ActiveServices.length > 0) {
          for (var i = 0; i < ActiveServices.length; i++) {
            this.servicios.push({
              id: ActiveServices[i].id,
              text: ActiveServices[i].text,
              value: ActiveServices[i].key,
              key: ActiveServices[i].key,
              auth: ActiveServices[i].auth,
              service_id: ActiveServices[i].service_id,
            });
          }


          if (ActiveServices.length == 1) {
            this.allowOutsideClick = false
            this.selectedService(this.servicios[0])
          } else {
            this.show = true;
          }

          //this.$router.push({name:  ActiveServices[0].component, params: {apm: this.apm, token: this.token}});
        } else {
          this.codError = '405';
          this.msg = '';
          this.type = '';
          this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
        }

/*         if (ActiveServices.length > 0) {
          for (var i = 0; i < ActiveServices.length; i++) {
            this.servicios.push({
              id: ActiveServices[i].id,
              text: ActiveServices[i].text,
              value: ActiveServices[i].key,
              key: ActiveServices[i].key,
              auth: ActiveServices[i].auth,
              service_id: ActiveServices[i].service_id,
            });
          }
          this.show = true;
        } else {
          this.codError = '405';
          this.msg = '';
          this.type = '';
          this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
        } */
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    async selectedService(service) {
      //let exit = false;
      if(service.auth) {
//        while (!exit) {
          await this.$swal.fire({
            title: 'Introduce tu código de acceso',
            input: 'password',
            inputPlaceholder: 'Introduce tu código de acceso',
            allowOutsideClick: this.allowOutsideClick,
            inputValidator: (value) => {
              if (!value) {
                return 'El código de acceso es necesario.'
              } else {
                this.accessCode = value
                if(this.accessCode) {
                  //let resulValidate =
                   this.validateAccessCode(service, this.accessCode);
                 /*  if(resulValidate) {
                    exit = true
                  } else {
                    exit = true
                  } */
                }
              }
            }
          })
//        }

/*         await this.$swal.fire({
          title: 'Introduce tu código de acceso',
          //html: '<div class="ui right icon input"><input type="password" id="mypassinput" required> <i class="ui large eye icon" v-on:click="showPass()" style="cursor:pointer"></i></div>',
           ////html: '<div class="ui right icon input"><input type="password" id="mypassinput" required>'+
          html: '<div class="ui right icon input">'+
                '<input type="password" id="mypassinput" placeholder="Introduce tu código de acceso">'+
                //'<a style="align-items:center; display:flex; color:#696969!important" v-on:click="showPass()">'+
                '<a style="align-items:center; display:flex; color:#696969!important" v-on:click="alert('zzzzz')">'+
                    '<i class="ui large eye icon" style="cursor:pointer"></i>'+
                  '</a>'+
                '</div>',
          confirmButtonText: 'OK'
        }).then((result) => {
          console.log(result)
          if (result.isConfirmed) {
            var ss=  document.getElementById('mypassinput').value
            if (ss) {
              this.accessCode = ss
              if (this.accessCode) {
                this.validateAccessCode(service, this.accessCode);
              }
            } else {
              //return 'Necesario introducir el código de acceso!'
              this.$swal({
                icon: 'info',
                text: 'Necesario introducir el código de acceso!',
              })
            }
          }
        }) */
      } else {
        this.showMenuServices(service);
      }
    },
    showPass() {
      console.log('icono ojoooo')
     /* var x = document.getElementById("mypassinput");
         //var x = window.getElementById("mypassinput");
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        } */
    },
    validateAccessCode(service, accessCode) {
      let url = this.$url_hapiick + '/v1/validations/access-code';
      let headers = {
          'Content-Type': 'application/json',
          'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url, {
        apm: this.apm,
        access_code: accessCode,
        service_id: service.service_id
      },{
        headers: headers
      })
      .then(request => {
        this.codError = request.data.error

        if (this.codError) {
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          this.validate_ok = request.data.validate_ok
          let sessionData = request.data.session.AptSession

          if (this.validate_ok) {
            localStorage.hapiickclient_id = sessionData.hapiick_client_id
            localStorage.virtualService_id = sessionData.service_id
            localStorage.user_id = sessionData.user_id
            this.showMenuServices(service);
          } else {
            if(this.totalIntentos < 3) {
              this.totalIntentos++;
              this.$swal({
                icon: 'error',
                title: 'Código de Acceso NO valido',
                text: 'El código introducido no existe. Por favor, vuelve a intentarlo.',
              }).then((result) => {
                //console.log(result)
                if (result.isConfirmed) {
                  this.selectedService(service)
                }
              })
            } else {
              this.codError = '';
              //this.msg = 'Has agotado el número de intentos. Por favor, vuelve a escanear el código QR.';
              this.msg = 'Has agotado el número de intentos. Si no recuerdas el código de acceso, por favor, ponte en contacto con nosotros.';
              this.type = 'error';
              this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
            }
          }
        }
      })
      .catch(error => {
        this.catchErrors(error);
      })
    },
    showMenuServices(service){
      let hs = service.id
      localStorage.virtualService_id = hs
      this.$router.push({name: 'MenuService'});
    },
    catchErrors(error){
      if(error.request) {
        if (error.request.status == 429) {
          this.codError = error.request.status
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          console.log(error.request)
        }
      }
    },
    redirect(codError, title, msg, type, token, closeSession) {
      this.$router.push({name: "Messages", params: {codError: codError, title: title, msg: msg, type: type, token: token, closeSession: closeSession}});
    },
  },
};
</script>

<style scoped>
a {
  color: darkslategrey;
}

form {
  width: 100%;
}

input, button {
  height: 55px;
  font-size: 17px !important;
}

i {
  margin:0px 15px 0px 15px!important;
}

i.big.icon, i.big.icons {
  color: #696969!important;
  font-size: 2.2em!important;
  width: 50px!important;
}

#contain {
  margin: auto!important;
  width: 95%;
  height: 85%;
  position: absolute;
  top: 10%;
  left: 2.5%;
  overflow: auto;
  padding-top: 0.5em!important;
  align-items: center;
}

.ui.fixed.menu + .ui.grid {
  padding-top: 0px !important;
}

.field {
  width: 100%;
}

.hapiick {
  background-color: white!important;
  border: 1px solid dimgrey!important;
  color: black !important;
}

.hapiick:hover {
  background-color: #00f9a9!important;
  border: 1px solid dimgrey!important;
}

.botonera {
  height:65px;
  display: flex;
  align-items: center;
}
</style>
